/**
 * src/actions/group-id-store.js
 */

import PermanentStore from './permanent-store'

const KEY = "gambaApp.group_id"
export default PermanentStore(KEY)


// WEBPACK FOOTER //
// ./src/actions/group-id-store.js